import { render } from "./STRIDeS.vue?vue&type=template&id=3fbc3423&scoped=true"
import script from "./STRIDeS.vue?vue&type=script&lang=js"
export * from "./STRIDeS.vue?vue&type=script&lang=js"

import "./STRIDeS.vue?vue&type=style&index=0&id=3fbc3423&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fbc3423"]])

export default __exports__